"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifferenceOnDays = void 0;
/**
 * Get difference on days between two dates
 * @public
 *
 * @param firstDate - First Date to compare with
 * @param secondDate - Second Date to compare with
 * @param includeEndDate - Include end date on counting
 *
 * @returns Number of days between firstDate and secondDate
 *
 * @example
 * ```ts
 * const daysBetweenDates = getDifferenceOnDays(
      new Date(2020, 1, 1),
      new Date(2020, 12, 31),
      false,
    )
 * console.log(daysBetweenDates);
 * // -> 365
 * ```
 */
function getDifferenceOnDays(firstDate, secondDate, includeEndDate = true) {
    return (Math.round((secondDate.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)) + (includeEndDate ? 1 : 0));
}
exports.getDifferenceOnDays = getDifferenceOnDays;
//# sourceMappingURL=get-difference-on-days.js.map